import React, { useState, useEffect } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import {
  GoogleMap,
  useLoadScript,
  Marker,
  Polygon,
  InfoWindow
} from '@react-google-maps/api';
import Moment from 'moment-timezone';
import { useCurrentUser } from '../../_services/hooks';
import { servicesAPI } from '../../_services';
import { Hub } from '../../_components/map/Features/Hub';
import { ChargePoint } from '../../_components/map/Features/ChargePoint';
import { UnderConstruction } from '../../_components/map/Features/UnderConstruction';
import { extendMoment } from 'moment-range';
// import { useCustomer } from '../../_services';
import { Container, Grid, Segment, Header, Input } from 'semantic-ui-react';
// import { startGeoLocationWatch } from '../../utils';
import './customerDetail_styles.css';

const moment = extendMoment(Moment);

const NO_UID = '00000000-0000-0000-0000-000000000000';
const googleMapsApiKey = 'AIzaSyC1_si0euik2ZbMw1dCcJHwqSEVGkDdcbQ'; // TDTODO move to Secret Manager

const libraries = ['places'];

const makeFeaturesFromHydra = (hubLocation, chargeStations, lod) => {
  const latLonArray = hubLocation.lat_lons;
  const description = hubLocation.description;

  const features = latLonArray.map((latLon, idx) => {
    let commissioning = false;
    let maintenance = false;
    let capped = false;
    let muted = false;
    let faulted = false;
    let charging = false;
    let future = hubLocation.lat_lons.length === 0;
    let url = '';
    let cs = {
      hydraReference: hubLocation.reference,
      description: hubLocation.description
    };
    if (chargeStations.length) {
      cs = chargeStations[idx];
      cs.hydraReference = hubLocation.reference;
      cs.description = hubLocation.description;

      commissioning = cs.tag_status === 'COMMISSIONING';
      maintenance = cs.tag_status === 'MAINTENANCE';
      capped = cs.status === 'Capped';
      muted = cs.status === 'Stopped';
      faulted = cs.status === 'Faulted';
      charging =
        cs.status === 'Occupied' &&
        cs.connected_lance_tag_id !== NO_UID &&
        cs.connected_lance_tag_id &&
        cs.transaction_id !== NO_UID;
      url = '';
    }

    const cpId = String(idx + 1).padStart(2, '0');

    return {
      isHUB: false,
      cs: cs,
      id: cpId,
      latLon: latLon,
      url: url,
      future: future,
      commissioning: commissioning,
      maintenance: maintenance,
      muted: muted,
      capped: capped,
      faulted: faulted,
      charging: charging,
      description: `${description} ${
        future ? '' : ' CS' + String(idx + 1).padStart(2, '0')
      }`,
      type: 'HUB',
      status: future
        ? 'Under Construction'
        : commissioning
        ? 'Commissioning'
        : maintenance
        ? 'Maintenance'
        : capped
        ? 'Unavailable'
        : muted
        ? 'Unavailable'
        : faulted
        ? 'Unavailable'
        : charging
        ? 'In use'
        : 'Available',
      link: url,
      hide_phalanx: cs
    };
  });

  if (lod === 'HIGH') return features;

  let latLon = features.length
    ? features[Math.floor(features.length / 2)].latLon
    : null;

  let numCSs = 0;
  let future = false;

  features.forEach(f => {
    if (f.capped) return;
    if (f.charging) return;
    if (f.faulted) return;
    if (f.muted) return;
    if (f.future) future = true;
    numCSs++;
  });

  const url = '';

  return [
    {
      isHUB: true,
      id: `${numCSs}`,
      latLon: latLon,
      url: url,
      numCSs: numCSs,
      future: future,
      description: hubLocation.description,
      type: 'HUB',
      status: '',
      link: url,
      hide_phalanx: false
    }
  ];
};

export const FindFreeCharger = ({ history, location: { pathname } }) => {
  const { currentUser, customerId } = useCurrentUser();
  // const { customer } = useCustomer(customerId);

  const [hubLocationInfo, setHubLocationInfo] = useState(
    window.hubLocationInfo
  );
  const [loadingHubInfo, setLoadingHubInfo] = useState(true);

  const [map, setMap] = useState(null);

  // const [locationOptions, setLocationOptions] = React.useState([]);
  // const [hydraReferences, setHydraReferences] = React.useState([]);

  const [postcode, setPostcode] = useState('');
  const [center, setCenter] = useState([
    -0.16884794366666664,
    51.557270876666664
  ]);
  const [zoom, setZoom] = useState(15.3);
  // const [chargerSearch, setChargerSearch] = useState(null);

  const [selectedMarker, setSelectedMarker] = useState(null);
  const [chargerFeatures, setChargerFeatures] = useState([]);
  // const [circleFeature, setCircleFeature] = useState([]);
  const [lod, setLOD] = useState('HIGH');

  const [phalanxes, setPhalanxes] = useState({});

  const [parkingZones, setParkingZones] = useState([]);
  const [occupiedSpaces, setOccupiedSpaces] = useState([]);
  const [freeSpaces, setFreeSpaces] = useState([]);
  const [lastUpdated, setLastUpdated] = React.useState('');
  // const [alertsEnabled, setAlertsEnabled] = useState(false);

  // Load Google Maps API
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: googleMapsApiKey,
    libraries
  });

  // async function getHydras() {
  //   try {
  //     const response = await servicesAPI.InventoryServices('getHydras');
  //     setLocationOptions(
  //       response
  //         .filter(h => h.tag_status === 'ACTIVE')
  //         // TDTODO should be in DB
  //         .filter(
  //           h =>
  //             h.reference.startsWith('hyd_l') || h.reference.startsWith('hub_l')
  //         )
  //         .sort((h1, h2) => h1.description.localeCompare(h2.description))
  //         .map(h => ({
  //           text: h.description,
  //           value: h.reference
  //         }))
  //     );
  //   } catch (error) {}
  // }

  // async function getChargerSearch(customerId) {
  //   try {
  //     const data = await servicesAPI.AdminServices(
  //       'getChargerSearch',
  //       customerId
  //     );
  //     setChargerSearch(data ? data : {});
  //     setHydraReferences(data.hydra_references);
  //   } catch (error) {}
  // }

  const setCenterByPostcode = code => {
    const address = code + ', UK';
    const encodedAddress = encodeURI(address);
    const apiKey = 'AIzaSyA3bCC3k5MfdlaCaS4gtizub3nCWyB3Wjo';
    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${apiKey}`
    )
      .then(response => response.json())
      .then(response => {
        if (response.results.length < 1) return;

        // Center map on postcode
        const location = response.results[0].geometry.location;
        setCenter([location.lng, location.lat]);

        // Find nearby chargers
        // const chargers = aons.filter(aon => {
        //   if (!aon.shared) return false;
        //
        //   // TDTODO
        //   // const distanceToCharger = distanceLatLong(
        //   //   location.lat,
        //   //   location.lng,
        //   //   aon.latitude,
        //   //   aon.longitude
        //   // );
        //   return true; //distanceToCharger <= distance;
        // });
        //
        // setChargerFeatures(makeFeaturesFromAons(chargers));
      })
      .catch(err => console.log(err));
  };

  // const upsertChargerSearch = async () => {
  //   // Toggle search status
  //   const status = chargerSearch.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
  //
  //   const newChargerSearch = {
  //     customer_id: customerId,
  //     status: status,
  //     hydra_references: hydraReferences,
  //     alerts: [] // Reset alert history
  //   };
  //
  //   try {
  //     await servicesAPI.AdminServices('upsertChargerSearch', newChargerSearch);
  //     setChargerSearch(newChargerSearch);
  //   } catch (error) {}
  // };

  async function getParkingData() {
    try {
      const zones = await servicesAPI.AdminServices('getParkingZones');
      zones.forEach(zone => {
        zone.data = JSON.parse(zone.data);
      });

      setParkingZones(zones);

      let occupied = [];
      let free = [];

      zones.forEach(zone => {
        zone.data.spaces.forEach(space => {
          if (space.type === 'occupied') occupied.push(space);
          else if (space.type === 'free') free.push(space);
        });
      });

      setOccupiedSpaces(occupied);
      setFreeSpaces(free);
    } catch (error) {}
  }

  async function getHydraPhalanxes() {
    let phalanxes = {};

    for (let i = 0; i < hubLocationInfo.length; i++) {
      const hubLocation = hubLocationInfo[i];
      try {
        if (hubLocation.tagId === 'MATG99999999-9999-9999-9999-999999999999') {
          // phalanxes[hydraId] = {};
        } else {
          let data1 = null;
          try {
            data1 = await servicesAPI.InventoryServices(
              'getHydraPhalanxes',
              hubLocation.tag_id
            );
          } catch (error) {}

          let data = null;
          try {
            data = data1.filter(p => !p.reference.endsWith('cs_00'));
          } catch (error) {}

          phalanxes[hubLocation.tag_id] = data;
        }
      } catch (error) {}
    }

    setPhalanxes(phalanxes);
  }

  // const setCurrentPosition = position => {
  //   const longitude = position.coords.longitude;
  //   const latitude = position.coords.latitude;
  //   // const accuracy = position.coords.accuracy;
  //   // const altitude = position.coords.altitude;
  //   // const altitudeAccuracy = position.coords.altitudeAccuracy;
  //   // const heading = position.coords.heading;
  //   // const speed = position.coords.speed;
  //
  //   setCenter([longitude, latitude]);
  // };

  // const positionError = error => {
  //   if (error.code === error.PERMISSION_DENIED)
  //     console.error('User denied the request for Geolocation');
  //   else if (error.code === error.POSITION_UNAVAILABLE)
  //     console.error('Location information is unavailable');
  //   else if (error.code === error.TIMEOUT)
  //     console.error('The request to get user location timed out');
  //   else if (error.code === error.UNKNOWN_ERROR)
  //     console.error('An unknown error occurred');
  // };

  useEffect(() => {
    if (!hubLocationInfo) return;
    // getHydras();

    getParkingData();
    getHydraPhalanxes();

    setLastUpdated(
      moment()
        .local()
        .format('HH:mm:ss')
    );

    // Refresh map every 10 seconds
    const interval = setInterval(() => {
      getParkingData();
      setLastUpdated(
        moment()
          .local()
          .format('HH:mm:ss')
      );
    }, 10000);
    return () => {
      clearInterval(interval);
    };
  }, [hubLocationInfo]); // eslint-disable-line

  useEffect(() => {
    if (!hubLocationInfo && loadingHubInfo) {
      servicesAPI
        .InventoryServices('getPhalanxLocationInfo')
        .then(hubLocationInfo => {
          let newHubLocationInfo = [];
          for (const hydraRef of Object.keys(hubLocationInfo)) {
            newHubLocationInfo.push({
              ...hubLocationInfo[hydraRef],
              reference: hydraRef
            });
          }
          window.hubLocationInfo = newHubLocationInfo;

          setLoadingHubInfo(false);
          setHubLocationInfo(newHubLocationInfo);
        });
    }
  }, [hubLocationInfo, loadingHubInfo]);

  useEffect(() => {
    if (customerId) {
      // getChargerSearch(customerId);

      // Track activity
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, '0');
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const yyyy = today.getFullYear();
      const h = String(today.getHours()).padStart(2, '0');
      const m = String(today.getMinutes()).padStart(2, '0');

      const when = yyyy + '.' + mm + '.' + dd + ' @ ' + h + ':' + m;

      const values = {
        when: when,
        who: `customer ${customerId}`,
        what: 'viewed DEICER page'
      };
      servicesAPI.AdminServices('logActivity', values);
    }
  }, [customerId]);

  // useEffect(() => {
  //   // TDTODO for testing - remove when live
  //   if (
  //     currentUser &&
  //     (currentUser.user_name === 'tom.dalziel@trojan.energy' ||
  //       currentUser.user_name === 'hugh@trojanenergyltd.com')
  //   )
  //     setAlertsEnabled(true);
  // }, [currentUser]);

  useEffect(() => {
    if (postcode.length >= 3) setCenterByPostcode(postcode);
  }, [postcode]);

  useEffect(() => {
    if (!hubLocationInfo || !phalanxes) return;

    let features = [];

    hubLocationInfo
      .filter(hubLocation => hubLocation.reference !== 'hub_l999901')
      .forEach(hubLocation => {
        let locPhalanxes = phalanxes[hubLocation.tag_id];
        if (!locPhalanxes) locPhalanxes = [];

        features = [
          ...features,
          ...makeFeaturesFromHydra(hubLocation, locPhalanxes, lod)
        ];
      });

    setChargerFeatures(features);
  }, [hubLocationInfo, phalanxes, lod]); // eslint-disable-line

  if (!currentUser) return <div>Loading...</div>;

  if (loadError) return <div>Google Maps loading failed</div>;

  if (!isLoaded) return <div>Loading...</div>;

  if (!chargerFeatures.length) return <div>Getting HUB data</div>;

  const underConstructionIcon = f => {
    return {
      anchor: new window.google.maps.Point(16, 16),
      url:
        'data:image/svg+xml;charset=utf-8,' +
        encodeURIComponent(
          renderToStaticMarkup(<UnderConstruction w={36} h={36} />)
        )
    };
  };

  const chargePointIcon = f => {
    return {
      anchor: new window.google.maps.Point(16, 16),
      url:
        'data:image/svg+xml;charset=utf-8,' +
        encodeURIComponent(
          renderToStaticMarkup(
            <ChargePoint
              w={36}
              h={36}
              colour={
                f.future
                  ? 'yellow'
                  : f.commissioning
                  ? 'orange'
                  : f.maintenance
                  ? 'orange'
                  : f.muted || f.capped
                  ? 'grey'
                  : f.faulted
                  ? 'red'
                  : f.charging
                  ? 'blue'
                  : 'green'
              }
              cpId={f.id}
              l1={f.charging}
              l2={f.charging}
              l3={f.charging}
              car={f.charging}
              lance={f.charging}
            />
          )
        )
    };
  };

  const hubIcon = f => {
    // Show customers number of available chargers
    const txt = f.numCSs;

    return {
      anchor: new window.google.maps.Point(16, 16),
      url:
        'data:image/svg+xml;charset=utf-8,' +
        encodeURIComponent(
          renderToStaticMarkup(
            <Hub
              w={48}
              h={48}
              colour={f.future ? 'yellow' : 'green'}
              txt={txt}
            />
          )
        )
    };
  };

  const defaultStyles = [
    {
      featureType: 'poi.business',
      stylers: [{ visibility: 'off' }]
    }
  ];

  const onMapMounted = ref => {
    if (ref && !map) setMap(ref);
  };

  return (
    <div>
      <Container>
        <Grid centered padded>
          <Grid.Column style={{ maxWidth: 500 }}>
            <div
              style={{
                marginBottom: '0px',
                minHeight: '660px',
                paddingLeft: '0px',
                paddingRight: '0px',
                paddingBottom: '0px'
              }}
            >
              <Segment>
                <Grid columns={1}>
                  <Grid.Row>
                    <Grid.Column textAlign="center">
                      <Header as="h2">FIND AVAILABLE CHARGEPOINT</Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Grid stretched>
                  <Grid.Row>
                    <Grid.Column>
                      Use the map below to check charger and parking
                      availability.
                      {/*alertsEnabled &&
                        'Or select an area and request alerts of free spaces near available chargers.'*/}
                      <br />
                      <Header as="h4">LIVE STATUS MAP:</Header>
                      <Input
                        placeholder="Search by postcode"
                        type="text"
                        name="postcode"
                        value={postcode}
                        onChange={(_, { value }) => {
                          setPostcode(value);
                        }}
                      />
                      <GoogleMap
                        options={{
                          streetViewControl: false,
                          gestureHandling: 'greedy',
                          styles: defaultStyles
                        }}
                        mapContainerStyle={{
                          width: '100%',
                          height: '800px'
                        }}
                        zoom={zoom}
                        center={{
                          lat: center[1],
                          lng: center[0]
                        }}
                        ref={onMapMounted}
                        onCenterChanged={() => {
                          if (map) {
                            const lon = map.state.map.center.lng();
                            const lat = map.state.map.center.lat();
                            if (lon !== center[0] || lat !== center[1])
                              setCenter([lon, lat]);
                          }
                        }}
                        onZoomChanged={() => {
                          if (map) {
                            const zoom = map.state.map.zoom;
                            setZoom(zoom);

                            // 00-13 Low
                            // 14-16 Medium
                            // 17-99 High
                            // const newLOD = zoom >= 17 ? 'HIGH' : zoom >= 14 ? 'MEDIUM' : 'LOW';
                            const newLOD = zoom >= 17 ? 'HIGH' : 'MEDIUM';

                            if (newLOD !== lod) setLOD(newLOD);
                          }
                        }}
                        // mapId={googleMapsMapId}
                      >
                        {selectedMarker ? (
                          <InfoWindow
                            onCloseClick={() => {
                              setSelectedMarker(null);
                            }}
                            position={{
                              lat: selectedMarker.latLon[0],
                              lng: selectedMarker.latLon[1]
                            }}
                          >
                            <div>
                              {selectedMarker.description ? (
                                selectedMarker.link ? (
                                  <>
                                    <a
                                      target="_blank"
                                      rel="noreferrer"
                                      href={selectedMarker.link}
                                    >
                                      {selectedMarker.description}
                                    </a>
                                  </>
                                ) : (
                                  selectedMarker.description
                                )
                              ) : (
                                ''
                              )}
                              <br />
                              {selectedMarker.type
                                ? 'Type: ' + selectedMarker.type
                                : ''}
                              <br />
                              {selectedMarker.status
                                ? 'Status: ' + selectedMarker.status
                                : ''}
                            </div>
                          </InfoWindow>
                        ) : (
                          ''
                        )}
                        {chargerFeatures
                          .filter(f => {
                            return (
                              !f.future &&
                              !f.commissioning &&
                              !f.maintenance &&
                              !f.capped &&
                              !f.muted &&
                              !f.faulted &&
                              !f.charging
                            );
                          })
                          .map(f => {
                            return f.future ? (
                              <Marker
                                position={{
                                  lat: f.latLon[0],
                                  lng: f.latLon[1]
                                }}
                                icon={underConstructionIcon(f)}
                                onClick={() => {
                                  setSelectedMarker(f);
                                }}
                              />
                            ) : f.isHUB ? (
                              <Marker
                                position={{
                                  lat: f.latLon[0],
                                  lng: f.latLon[1]
                                }}
                                icon={hubIcon(f)}
                                onClick={() => {
                                  setSelectedMarker(f);
                                }}
                              />
                            ) : (
                              <Marker
                                position={{
                                  lat: f.latLon[0],
                                  lng: f.latLon[1]
                                }}
                                icon={chargePointIcon(f)}
                                onClick={() => {
                                  setSelectedMarker(f);
                                }}
                              />
                            );
                          })}
                        {lod === 'HIGH'
                          ? parkingZones.map(z => (
                              <Polygon
                                path={[
                                  { lat: z.data.ax, lng: z.data.ay },
                                  { lat: z.data.bx, lng: z.data.by },
                                  { lat: z.data.cx, lng: z.data.cy },
                                  { lat: z.data.dx, lng: z.data.dy }
                                ]}
                                options={{
                                  fillColor: 'white',
                                  fillOpacity: 0.0,
                                  strokeColor: '#0000ff',
                                  strokeOpacity: 0.8,
                                  strokeWeight: 3
                                }}
                                onClick={() => {}}
                              />
                            ))
                          : ''}
                        {lod === 'HIGH'
                          ? occupiedSpaces.map(s => (
                              <Polygon
                                path={[
                                  { lat: s.raw_ax, lng: s.raw_ay },
                                  { lat: s.raw_bx, lng: s.raw_by },
                                  { lat: s.raw_cx, lng: s.raw_cy },
                                  { lat: s.raw_dx, lng: s.raw_dy }
                                ]}
                                options={{
                                  fillColor: 'red',
                                  fillOpacity: 0.4,
                                  strokeColor: '#d35400',
                                  strokeOpacity: 0.8,
                                  strokeWeight: 3
                                }}
                                onClick={() => {}}
                              />
                            ))
                          : ''}
                        {lod === 'HIGH' &&
                          freeSpaces.map(s => (
                            <Polygon
                              path={[
                                { lat: s.raw_ax, lng: s.raw_ay },
                                { lat: s.raw_bx, lng: s.raw_by },
                                { lat: s.raw_cx, lng: s.raw_cy },
                                { lat: s.raw_dx, lng: s.raw_dy }
                              ]}
                              options={{
                                fillColor: 'green',
                                fillOpacity: 0.4,
                                strokeColor: '#004000',
                                strokeOpacity: 0.8,
                                strokeWeight: 3
                              }}
                              onClick={() => {}}
                            />
                          ))}
                      </GoogleMap>
                      <p>Last updated: {lastUpdated}</p>
                      <b>KEY:</b>
                      Free parking space = 🟩 green rectangle
                      <br />
                      Occupied parking space = 🟥 red rectangle
                      <br />
                      Free charge points = 🟢 green circle
                      <br />
                      <br />
                      (Parking information updates every 2 minutes.)
                      <br />
                      {/*alertsEnabled && (
                        <>
                          <Header as="h4">RECEIVE ALERTS:</Header>
                          Alert me if charge points become available on the
                          following streets.
                          <br />
                          <br />
                          <Dropdown
                            placeholder="Select streets"
                            selection
                            search
                            options={locationOptions}
                            multiple
                            onChange={(e, inputProps) => {
                              setHydraReferences(inputProps.value);
                            }}
                            value={hydraReferences}
                            disabled={
                              chargerSearch && chargerSearch.status === 'ACTIVE'
                            }
                          />
                          <br />
                          <Button
                            style={{ width: '100%' }}
                            onClick={event => {
                              upsertChargerSearch();
                            }}
                            color={
                              chargerSearch && chargerSearch.status === 'ACTIVE'
                                ? 'red'
                                : 'olive'
                            }
                          >
                            {chargerSearch && chargerSearch.status === 'ACTIVE'
                              ? 'STOP ALERTS'
                              : 'ENABLE ALERTS'}
                          </Button>
                          <Button
                            style={{ width: '100%' }}
                            onClick={event => {
                              startGeoLocationWatch(
                                setCurrentPosition,
                                positionError
                              );
                            }}
                            color={'olive'}
                          >
                            USE DEVICE GPS TO LOCATE ME
                          </Button>
                        </>
                      )*/}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            </div>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};
